export const PROVIDER_LOGIN_REQUIRED_MESSAGE = 'La sesión del proveedor caducó: vuelve a iniciar sesión';
